// @ts-check
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import {
  Button,
  Container,
  P,
  SemiTitle,
} from '@bottlebooks/gatsby-theme-base';
import { Trans } from '@lingui/macro';
import React from 'react';
import { jsx } from 'theme-ui';
import useAuthentication from '../../../gatsby-plugin-firebase-auth/src/useAuthentication';
import { useEducationalContentDialog } from './EducationalContentDialog';
import FeatureOverview from './FeatureOverview';

export default function LoggedOut() {
  const { signIn } = useAuthentication();
  const { setHasBeenShown } = useEducationalContentDialog();

  return (
    <Container sx={{ paddingBottom: 5, paddingTop: 4 }}>
      <FeatureOverview />
      <Button
        variant="primary"
        onClick={() => {
          setHasBeenShown();
          signIn();
        }}
        sx={{ marginTop: 2 }}
      >
        <Trans>Create account</Trans>
      </Button>
      <SemiTitle sx={{ marginTop: 4 }}>
        <Trans>Where is my list?</Trans>
      </SemiTitle>
      <P>
        <Trans>
          Did you create a list on another device? Login to access it on this
          device.
        </Trans>
      </P>
      <Button
        variant="outline"
        onClick={() => {
          setHasBeenShown();
          signIn();
        }}
      >
        <Trans>Log in to download to this device</Trans>
      </Button>
    </Container>
  );
}
